<template>
    <div class="customer-revenue">
        <div class="placeholder">
            <div class="placeholder__heading">
                {{ name }} kr.
            </div>
            <div class="placeholder">
                
                <vue-good-table
                    :columns="columns"
                    :rows="customers"
                    :search-options="searchOptions"
                    :pagination-options="paginationOptions"
                    :sort-options="sortOptions"
                    :styleClass="styleClass"
                    :v-if="customers.length"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                            {{ props.row.coverage_percent | rounded }} 
                            <div
                                v-if="props.row.coverage_percent !== null"
                                class="coverage-indicator"
                                :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                            />
                        </div>
                        <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name">
                            {{ props.row.name }}
                        </div>
                        <div v-else-if="props.column.field == 'coverage'">
                            {{ props.row.coverage | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'invoices_total'">
                            {{ props.row.invoices_total | currency }}
                        </div>
                        <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                    {{ props.row.coverage_per_hour | currency }} 
                    <div
                        v-if="props.row.coverage_per_hour !== null"
                        class="coverage-indicator"
                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                    />
                </div>
                        <div v-else :title="props.formattedRow[props.column.field]">
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customers: {
            type: Array,
            default: () => {
                return []
            }
        },
        name: {
            type: String
        }
    },
    data () {
        return {
            selectedRow: null,
            rows: [],
            columns: [
                { label: 'Kunde', field: 'name', type: 'string' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    }
}
</script>



// WEBPACK FOOTER //
// customerGroupedSingle.vue?271099a4